import type { ReactNode } from 'react';
import type { UserProfileDto } from '../../../domain/contracts/api.contracts';
import { useTranslation } from '../../../application/hooks/useTranslation';
import { formatDate } from '../../../domain/formatters/date';
import { Badge } from '../ui/Badge';
import { Card } from '../ui/Card';

/** W04 — read-only KYC tiles (PRD §6.1). Null / missing backend values render "Not on record". */
export function KycDetailsCard({ user }: { user: UserProfileDto }) {
  const { t, locale } = useTranslation();
  const notOnRecord = <span className="muted">{t('profile.notOnRecord')}</span>;
  const rows: Array<[string, ReactNode]> = [
    [t('profile.nid'), user.nidMasked ? <span className="tabular">{user.nidMasked}</span> : notOnRecord],
    [t('auth.phone'), <span className="tabular">{user.phone}</span>],
    [t('profile.address'), user.address || notOnRecord],
    [t('profile.onboardedAt'), user.onboardedAt ? formatDate(user.onboardedAt, locale) : notOnRecord],
    [
      t('profile.kycStatus'),
      user.kycVerified === undefined ? (
        notOnRecord
      ) : (
        <Badge tone={user.kycVerified ? 'success' : 'neutral'}>
          {user.kycVerified ? t('profile.kycVerified') : t('profile.kycNotVerified')}
        </Badge>
      ),
    ],
  ];
  return (
    <Card title={t('profile.kyc')}>
      <dl className="kv" data-testid="kyc-card">
        {rows.map(([label, value]) => (
          <div key={label} style={{ display: 'contents' }}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    </Card>
  );
}
